const assetPrefix = process.env.REACT_APP_CDN_ASSET_PREFIX || "/assets";

const badgeImageMap = {
  GoldBadge: `${assetPrefix}/images/badges/Gold.svg`,
  SilverBadge: `${assetPrefix}/images/badges/Silver.svg`,
  BronzeBadge: `${assetPrefix}/images/badges/Bronze.svg`,
  StreakBadgeFirst: `${assetPrefix}/images/badges/streak_badge_first.png`,
  StreakBadge5Day: `${assetPrefix}/images/badges/streak_badge_5day.png`,
  StreakBadge30Day: `${assetPrefix}/images/badges/streak_badge_30day.png`,
  StreakBadgeTeam: `${assetPrefix}/images/badges/streak_badge_team.png`,
  StreakBadgeAllTime: `${assetPrefix}/images/badges/streak_badge_alltime.png`,
  RevenueBadge25k: `${assetPrefix}/images/badges/revenue_badge_25k.png`,
  RevenueBadge50k: `${assetPrefix}/images/badges/revenue_badge_50k.png`,
  RevenueBadge100k: `${assetPrefix}/images/badges/revenue_badge_100k.png`,
  RevenueBadge500k: `${assetPrefix}/images/badges/revenue_badge_500k.png`,
  RevenueBadge1M: `${assetPrefix}/images/badges/revenue_badge_1M.png`,
  DemoBadge1: `${assetPrefix}/images/badges/demo_badge_1.png`,
  DemoBadge5: `${assetPrefix}/images/badges/demo_badge_5.png`,
  DemoBadge25: `${assetPrefix}/images/badges/demo_badge_25.png`,
  DemoBadge50: `${assetPrefix}/images/badges/demo_badge_50.png`,
  DemoBadge100: `${assetPrefix}/images/badges/demo_badge_100.png`,
  DemoBadge250: `${assetPrefix}/images/badges/demo_badge_250.png`,
  DemoBadge500: `${assetPrefix}/images/badges/demo_badge_500.png`,
  DemoBadge1000: `${assetPrefix}/images/badges/demo_badge_1000.png`,
  DiscoBadge1: `${assetPrefix}/images/badges/disco_badge_1.png`,
  DiscoBadge5: `${assetPrefix}/images/badges/disco_badge_5.png`,
  DiscoBadge25: `${assetPrefix}/images/badges/disco_badge_25.png`,
  DiscoBadge50: `${assetPrefix}/images/badges/disco_badge_50.png`,
  DiscoBadge100: `${assetPrefix}/images/badges/disco_badge_100.png`,
  DiscoBadge250: `${assetPrefix}/images/badges/disco_badge_250.png`,
  DiscoBadge500: `${assetPrefix}/images/badges/disco_badge_500.png`,
  DiscoBadge1000: `${assetPrefix}/images/badges/disco_badge_1000.png`,
  OppBadge1: `${assetPrefix}/images/badges/opp_badge_1.png`,
  OppBadge5: `${assetPrefix}/images/badges/opp_badge_5.png`,
  OppBadge25: `${assetPrefix}/images/badges/opp_badge_25.png`,
  OppBadge50: `${assetPrefix}/images/badges/opp_badge_50.png`,
  OppBadge100: `${assetPrefix}/images/badges/opp_badge_100.png`,
  OppBadge250: `${assetPrefix}/images/badges/opp_badge_250.png`,
  OppBadge500: `${assetPrefix}/images/badges/opp_badge_500.png`,
  OppBadge1000: `${assetPrefix}/images/badges/opp_badge_1000.png`,
  OrangeBadge1: `${assetPrefix}/images/badges/orange_badge_1.png`,
  OrangeBadge10: `${assetPrefix}/images/badges/orange_badge_10.png`,
  OrangeBadge25: `${assetPrefix}/images/badges/orange_badge_25.png`,
  OrangeBadge50: `${assetPrefix}/images/badges/orange_badge_50.png`,
  OrangeBadge100: `${assetPrefix}/images/badges/orange_badge_100.png`,
  OrangeBadge250: `${assetPrefix}/images/badges/orange_badge_250.png`,
  OrangeBadge500: `${assetPrefix}/images/badges/orange_badge_500.png`,
  OrangeBadge1000: `${assetPrefix}/images/badges/orange_badge_1000.png`,
  BlueBadge1: `${assetPrefix}/images/badges/blue_badge_1.png`,
  BlueBadge10: `${assetPrefix}/images/badges/blue_badge_10.png`,
  BlueBadge25: `${assetPrefix}/images/badges/blue_badge_25.png`,
  BlueBadge50: `${assetPrefix}/images/badges/blue_badge_50.png`,
  BlueBadge100: `${assetPrefix}/images/badges/blue_badge_100.png`,
  BlueBadge250: `${assetPrefix}/images/badges/blue_badge_250.png`,
  BlueBadge500: `${assetPrefix}/images/badges/blue_badge_500.png`,
  BlueBadge1000: `${assetPrefix}/images/badges/blue_badge_1000.png`,
  GreenBadge1: `${assetPrefix}/images/badges/green_badge_1.png`,
  GreenBadge10: `${assetPrefix}/images/badges/green_badge_10.png`,
  GreenBadge25: `${assetPrefix}/images/badges/green_badge_25.png`,
  GreenBadge50: `${assetPrefix}/images/badges/green_badge_50.png`,
  GreenBadge100: `${assetPrefix}/images/badges/green_badge_100.png`,
  GreenBadge250: `${assetPrefix}/images/badges/green_badge_250.png`,
  GreenBadge500: `${assetPrefix}/images/badges/green_badge_500.png`,
  GreenBadge1000: `${assetPrefix}/images/badges/green_badge_1000.png`,
  PinkBadge1: `${assetPrefix}/images/badges/pink_badge_1.png`,
  PinkBadge10: `${assetPrefix}/images/badges/pink_badge_10.png`,
  PinkBadge25: `${assetPrefix}/images/badges/pink_badge_25.png`,
  PinkBadge50: `${assetPrefix}/images/badges/pink_badge_50.png`,
  PinkBadge100: `${assetPrefix}/images/badges/pink_badge_100.png`,
  PinkBadge250: `${assetPrefix}/images/badges/pink_badge_250.png`,
  PinkBadge500: `${assetPrefix}/images/badges/pink_badge_500.png`,
  PinkBadge1000: `${assetPrefix}/images/badges/pink_badge_1000.png`,
  PurpleBadge1: `${assetPrefix}/images/badges/purple_badge_1.png`,
  PurpleBadge10: `${assetPrefix}/images/badges/purple_badge_10.png`,
  PurpleBadge25: `${assetPrefix}/images/badges/purple_badge_25.png`,
  PurpleBadge50: `${assetPrefix}/images/badges/purple_badge_50.png`,
  PurpleBadge100: `${assetPrefix}/images/badges/purple_badge_100.png`,
  PurpleBadge250: `${assetPrefix}/images/badges/purple_badge_250.png`,
  PurpleBadge500: `${assetPrefix}/images/badges/purple_badge_500.png`,
  PurpleBadge1000: `${assetPrefix}/images/badges/purple_badge_1000.png`,
};

export default badgeImageMap;
